import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=324b315c&"
import script from "./FollowUp.vue?vue&type=script&lang=js&"
export * from "./FollowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324b315c')) {
      api.createRecord('324b315c', component.options)
    } else {
      api.reload('324b315c', component.options)
    }
    module.hot.accept("./FollowUp.vue?vue&type=template&id=324b315c&", function () {
      api.rerender('324b315c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/onboarding/components/FollowUp.vue"
export default component.exports